import { createContext, useState, useEffect } from "react";

export const AdminThemeContext = createContext();

export const AdminThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    header: "#ffffff",
    sidebar: "#111827",
    background: "#f8f9fa",
    dark: false,
  });

  // load saved settings
  useEffect(() => {
    const saved = localStorage.getItem("admin-theme");
    if (saved) setTheme(JSON.parse(saved));
  }, []);

  // apply styles + save
  useEffect(() => {
    localStorage.setItem("admin-theme", JSON.stringify(theme));

    document.documentElement.style.setProperty("--header-color", theme.header);
    document.documentElement.style.setProperty("--sidebar-bg", theme.sidebar);
    document.documentElement.style.setProperty("--page-bg", theme.background);

    document.body.style.background = theme.background;
    document.body.className = theme.dark ? "dark" : "";

  }, [theme]);

  return (
    <AdminThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </AdminThemeContext.Provider>
  );
};